module.exports = __webpack_public_path__ + "img/research_medicine.4498030c.svg";